'use strict';

// array to keep track of the dynamically loaded CSS files
let loadedCssFiles = [];

/**
 * @function
 * @description Loads css file dynamically from given url
 * @param {String} url The url from which css file will be dynamically loaded.
 */
const loadCssFile = (url) => {
    return $('<link/>').appendTo($('head')).attr({
        type: 'text/css',
        rel: 'stylesheet'
    }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
};

/**
 * @function
 * @description Loads css dynamically from given urls
 * @param {Array} urls Array of urls from which css will be dynamically loaded.
 */
const loadDynamicCss = (urls) => {
    const len = urls.length;
    for (let i = 0; i < len; i++) {
        loadedCssFiles.push(loadCssFile(urls[i]));
    }
};

/**
 * @function
 * @description Removes all css files which were dynamically loaded
 */
const clearDynamicCss = () => {
    let i = loadedCssFiles.length;
    while (0 > i--) {
        $(loadedCssFiles[i]).remove();
    }
    loadedCssFiles = [];
};

module.exports = {
    loadCssFile: loadCssFile,
    loadDynamicCss: loadDynamicCss,
    clearDynamicCss: clearDynamicCss
};
